import { z } from 'zod';
export const actionBriefSchema = z.object({
    action: z.string().trim().min(1).max(4000),
    why: z.string().trim().min(1).max(3000),
    strategy: z.string().trim().min(1).max(5000),
    resourcesCommitted: z.string().trim().min(1).max(3000),
    organizationsInvolved: z.string().trim().min(1).max(2000),
    intendedOutcome: z.string().trim().min(1).max(3000),
    timeHorizon: z.string().trim().min(1).max(500),
});
export const actionBriefWorkspaceCommandSchema = z
    .object({
    expectedWorkspaceVersion: z.number().int().nonnegative(),
    action: z.enum(['SAVE_DRAFT', 'DELETE_DRAFT', 'SUBMIT']),
    brief: actionBriefSchema.optional(),
})
    .superRefine((value, context) => {
    if ((value.action === 'SAVE_DRAFT' || value.action === 'SUBMIT') && !value.brief) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['brief'],
            message: 'Brief is required',
        });
    }
    if (value.action === 'DELETE_DRAFT' && value.brief) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['brief'],
            message: 'Delete does not accept a brief',
        });
    }
});
export const officialSubmissionMetadataSchema = z.object({
    id: z.string(),
    version: z.number().int().positive(),
    submittedAt: z.string().datetime(),
});
export const actionBriefWorkspaceSchema = z.object({
    gameId: z.string(),
    roundNo: z.number().int().positive(),
    teamId: z.string(),
    workspaceVersion: z.number().int().nonnegative(),
    locked: z.boolean(),
    currentDraft: actionBriefSchema.optional(),
    officialBrief: actionBriefSchema.optional(),
    officialSubmission: officialSubmissionMetadataSchema.optional(),
});
export const workspaceConflictSchema = z.object({
    code: z.enum(['WORKSPACE_STALE', 'ROUND_LOCKED']),
    message: z.string(),
    correlationId: z.string().optional(),
    workspaceVersion: z.number().int().nonnegative(),
    locked: z.boolean(),
    officialSubmissionId: z.string().optional(),
    officialSubmittedAt: z.string().datetime().optional(),
});
//# sourceMappingURL=action-brief.js.map